import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { TransactionService } from 'src/app/pages/transaction-admin/services/transaction.service';
import { TransactionExternalService } from 'src/app/pages/transaction/services/transaction-external.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { Router, ActivatedRoute } from '@angular/router';
import { TransactionRequirementItemServiceService } from 'src/app/pages/transaction/services/transaction-requirement-item.service';
import { Subscription } from 'rxjs';
import { TransactionRevisionExternalService } from 'src/app/pages/transaction/services/transaction-revision-status-external.service';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';

@Component({
	selector: 'pdf-viewer',
	templateUrl: './pdf-viewer.component.html',
	styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent extends BaseManagement implements OnInit {
	@Input() validateForm = false;
	requirement: any;
	serverError: any = '';
	pdfSrc: any;
	requirementItem: any;
	itemToEdit: any = { Id: null }
	minimize: boolean = false;
	subscriptions: Subscription[] = [];
	revisionStatusLog: any = {};
	public downloaded: string | undefined;

	isFormValid: boolean = false;
	formData: any = null;

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public mainService: TransactionRequirementService,
		public ngxService: NgxExtendedPdfViewerService,
		public transactionService: TransactionService,
		public transactionExternalService: TransactionExternalService,
		public translate: TranslateService,
		public transactionRequirementItemServiceService: TransactionRequirementItemServiceService,
		public transactionRevisionExternalService: TransactionRevisionExternalService
	) {
		super();

		this.mainService.pdfCommunicator.subscribe((data) => {
			if (data == "save-data") {
				this.tryDownloadAsBlob("submit-for-review");
			}
		});
	}

	ngOnInit() {

		this.requirementItem = this.transactionRequirementItemServiceService.requirementItem;

		console.log(this.requirementItem);
		this.pdfSrc = this.mainService.fileToLoad;
		let params: any = {};
		params.userProcessId = this.requirementItem.ProcessId;
		params.requirementId = this.requirementItem.RequirementId;

		this.transactionRevisionExternalService.getRevisionStatusLog(params)
			.then((data: any) => {
				this.revisionStatusLog = {
					CompletedDate: "n/a",
					RemediedDate: "n/a"
				};
				if (data) {
					this.revisionStatusLog = data;
				}
				console.log(this.revisionStatusLog);
				this.validateRequiredFields();
			})
			.catch((err) => {
				console.log('error', err);
				this.serverError = "An error ocurred when getting the revision status log."
			});

	}

	validateRequiredFields(): boolean {
		// debugger;
		let formData: any = this.mainService.formData;
		
		// Objeto para almacenar las propiedades que contengan 'required' en su nombre
		let requiredFieldsObject: any = {};
		let requiredFieldsCount = 0;
		
		// Verificar que formData existe y es un objeto
		if (formData && typeof formData === 'object') {
			// Iterar sobre todas las propiedades del objeto formData
			for (let propertyName in formData) {
				// Verificar si la propiedad contiene la palabra 'required' en su nombre
				if (propertyName.toLowerCase().includes('required')) {
					requiredFieldsObject[propertyName] = formData[propertyName];
					requiredFieldsCount++;
				}
			}
		}
		
		// Verificar si todas las propiedades required tienen valor
		for (let propertyName in requiredFieldsObject) {
			let value = requiredFieldsObject[propertyName];
			// Verificar si el valor es string vacío, null, undefined
			if (value === '' || value === null || value === undefined) {
				this.isFormValid = false;
				return false; // Al menos una no tiene valor
			}
		}
		
		// Si llegamos aquí, todas tienen valor
		this.isFormValid = true
		return true;
	}

	ngOnDestroy() {
		this.subscriptions.forEach(s => s.unsubscribe());
	}

	trySubmitForReview(action) {
		if (this.isSaving()) return;

		this.mainService.pdfCommunicator
			.next("save-data")
	}

	minimizeRevisionAlert(action) {
		this.minimize = false;
		if (action == true) {
			this.minimize = true
		}
	}

	close() {

		this.translate
			.get([
				'message.deleteConfirmText',
				'message.yes',
				'message.no',
				'message.requirement',
				'message.deleted',
				'message.unableRequirement',
				'message.done',
				'pdfform.closeWarn',
			])
			.subscribe((translations) => {
				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['pdfform.closeWarn'],
						yesText: translations['message.yes'],
						noText: translations['message.no'],
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 1) {
						this.mainService.fileToLoad = null;
					}
				});
			});
	}

	tryDownloadAsBlob(action) {
		if (!this.isFormValid) {
			this.alertCompleteForm();
			return;
		}

		if (this.isSaving()) return;

		this.translate
			.get([
				'message.deleteConfirmText',
				'message.yes',
				'message.no',
				'message.requirement',
				'message.deleted',
				'message.unableRequirement',
				'message.done',
				'pdfform.saveWarn',
			])
			.subscribe((translations) => {
				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['pdfform.saveWarn'],
						yesText: translations['message.yes'],
						noText: translations['message.no'],
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 1) {
						this.startSaving(action);
						this.downloadAsBlob(action);
					}
				});
			});
	}

	public async downloadAsBlob(action): Promise<void> {
		const blob = await this.ngxService.getCurrentDocumentAsBlob();
		if (blob) {
			this.downloaded = 'The BLOB contains ' + blob.size + ' byte.';

			var formData = new FormData();
			var files: File[] = [];
			var filePdf = new File([blob], "name.pdf");
			files.push(filePdf);

			Array.from(files).forEach((f) => formData.append('file', f));

			formData.append('id', this.mainService.UserProcessRequirementId);
			formData.append('processId', this.mainService.ProcessId);
			
			// Convertir saltos de línea a etiquetas HTML <br>
			console.log('📋 Datos originales:', this.mainService.formData);
			const sanitizedFormData = this.convertNewLinesToHtml(this.mainService.formData);
			console.log('✅ Datos con <br>:', sanitizedFormData);
			formData.append('pdfFormJson', JSON.stringify(sanitizedFormData));
			
			formData.append('fileName', this.mainService.FileName);
			this.mainService
				.uploadRequirementFile(formData)
				.then((updatedRequirement) => {

					this.mainService.pdfCommunicator.next("stop-saving");

					this.requirement = updatedRequirement;

					this.mainService.updateItemByField(
						this.requirement.UserProcessRequirementId,
						'UserProcessRequirementId',
						this.requirement
					);

					this.transactionService
						.getTimeline(this.requirement.ProcessId)
						.then(() => {
							this.mainService.fileToLoad = null;
							/*   this.transactionService.getTransactionsForUser()
							  .then(()=>{
			
								
							  }); */

						});
				})
				.catch((err) => {
					console.log('error', err);
					this.translate
						.get(['error.documentUplaod'])
						.subscribe((translations) => {
							this.stopSaving();

							this.serverError = "Hubo un problema al intentar enviar el documento"
						});
				});

		} else {
			this.downloaded = 'download failed';
			this.stopSaving();
		}
	}

	onFormChange(event: any) {
		if (this.validateForm) {
			this.validateRequiredFields();
		} else {
			this.isFormValid = true;
		}
	}

	alertCompleteForm() {
		const dialogRef = this.dialog.open(DialogOkComponent, {
			data: {
				msg: 'Rellene todos los campos obligatorios.',
			}
		});

		dialogRef.afterClosed().subscribe((res: any) => { });
	}

	/**
	 * Convierte los saltos de línea (\n) a etiquetas HTML <br> para que se 
	 * muestren correctamente en el PDF generado
	 * @param data Objeto con los datos del formulario
	 * @returns Objeto con los datos convertidos
	 */
	private convertNewLinesToHtml(data: any): any {
		const converted: any = {};
		
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				let value = data[key];
				
				// Si es un string, convertir saltos de línea a <br>
				if (typeof value === 'string') {
					// Normalizar diferentes tipos de saltos de línea
					value = value.replace(/\r\n/g, '\n'); // Windows
					value = value.replace(/\r/g, '\n');   // Mac antiguo
					
					// Convertir \n a <br>
					value = value.replace(/\n/g, '<br>');
				}
				
				converted[key] = value;
			}
		}
		
		return converted;
	}
}
